const notReport = email => email.actionMethod !== 'send_report'

export default notReport
